import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const ProtectedRoute = ({ component: Component, isAuthenticated, user, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => (isAuthenticated && !!user.isAdmin ? <Component {...props} /> : <Redirect to="/" />)}
    />
  );
};

const mapStateToProps = state => state;

ProtectedRoute.propTypes = {
  component: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    isAdmin: PropTypes.bool,
  }),
};

export default connect(mapStateToProps)(ProtectedRoute);
